// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container */
.mhCJxb {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: var(--spacing-3);
  padding: var(--spacing-3);
  height: 840px;
  background-color: var(--background-white);
}

/* Header */
.dVBnqb {
  display: flex;
  align-self: stretch;
  gap: var(--spacing-3);
  align-items: center;
  justify-content: space-between;
}

.an1aL5 {
  flex: 1;
}

.amfJQC {
  display: flex;
  align-items: center;
  gap: var(--spacing-1-5);
}

.H9gwaS {
  height: 32px;
  padding: var(--spacing-0-5) var(--spacing-1);
  gap: var(--spacing-0-5);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm);
  line-height: 1.424;
}

/* PDF Container */
.mabNUb {
  display: flex;
  flex-direction: column;
  flex: 1;
  align-self: stretch;
  overflow-y: auto;
  border-radius: var(--radius-s);
  box-shadow: var(--shadow-card);
  background-color: var(--background-white);
}

.IcOGDF {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-2);
  padding: var(--spacing-2);
}

.bpFoWL {
  box-shadow: var(--shadow-sm);
  border-radius: var(--radius-s);
  overflow: hidden;
}

/* Loading State */
.DW7Ay1 {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
}

.cPZka2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-2);
  flex: 1;
  color: var(--text-neutral-stronger);
}

.nqfUuL {
  width: var(--spacing-4);
  height: var(--spacing-4);
  animation: TOYuqD 1s linear infinite;
}

@keyframes TOYuqD {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Error State */
.ny0yUK {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-2);
  flex: 1;
  color: var(--status-error);
}

.hKLUMP {
  width: var(--spacing-4);
  height: var(--spacing-4);
}

/* PDF Loading/Error States */
.XouMaG {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-2);
  padding: var(--spacing-4);
  color: var(--text-neutral-stronger);
}

.UI7UZW {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-2);
  padding: var(--spacing-4);
  color: var(--status-error);
}

.gKcqBe {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-2);
  color: var(--text-neutral-stronger);
  font-size: var(--font-size-sm);
}

.qBjSUO {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-2);
  flex: 1;
  color: var(--text-neutral-stronger);
}

.HqCty6 {
  width: var(--spacing-4);
  height: var(--spacing-4);
}

/* Responsive Design */
@media (max-width: var(--grid-breakpoint-xs)) {
  .mhCJxb {
    padding: var(--spacing-2);
    height: auto;
    min-height: 100vh;
  }

  .dVBnqb {
    flex-direction: column;
    align-items: stretch;
    gap: var(--spacing-2);
  }

  .amfJQC {
    justify-content: center;
  }

  .IcOGDF {
    padding: var(--spacing-1);
  }

  .bpFoWL {
    max-width: 100%;
    height: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/ChargesPDFViewer/ChargesPDFViewer.module.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;EACb,yCAAyC;AAC3C;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,4CAA4C;EAC5C,uBAAuB;EACvB,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,OAAO;EACP,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,oCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,OAAO;EACP,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,OAAO;EACP,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA,sBAAsB;AACtB;EACE;IACE,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF","sourcesContent":["/* Container */\n.container {\n  display: flex;\n  flex-direction: column;\n  align-self: stretch;\n  gap: var(--spacing-3);\n  padding: var(--spacing-3);\n  height: 840px;\n  background-color: var(--background-white);\n}\n\n/* Header */\n.header {\n  display: flex;\n  align-self: stretch;\n  gap: var(--spacing-3);\n  align-items: center;\n  justify-content: space-between;\n}\n\n.breadcrumb {\n  flex: 1;\n}\n\n.actions {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1-5);\n}\n\n.downloadButton {\n  height: 32px;\n  padding: var(--spacing-0-5) var(--spacing-1);\n  gap: var(--spacing-0-5);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-sm);\n  line-height: 1.424;\n}\n\n/* PDF Container */\n.pdfContainer {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  align-self: stretch;\n  overflow-y: auto;\n  border-radius: var(--radius-s);\n  box-shadow: var(--shadow-card);\n  background-color: var(--background-white);\n}\n\n.pdfDocument {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--spacing-2);\n  padding: var(--spacing-2);\n}\n\n.pdfPage {\n  box-shadow: var(--shadow-sm);\n  border-radius: var(--radius-s);\n  overflow: hidden;\n}\n\n/* Loading State */\n.loadingContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n}\n\n.loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-2);\n  flex: 1;\n  color: var(--text-neutral-stronger);\n}\n\n.loadingIcon {\n  width: var(--spacing-4);\n  height: var(--spacing-4);\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Error State */\n.error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-2);\n  flex: 1;\n  color: var(--status-error);\n}\n\n.errorIcon {\n  width: var(--spacing-4);\n  height: var(--spacing-4);\n}\n\n/* PDF Loading/Error States */\n.pdfLoading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-2);\n  padding: var(--spacing-4);\n  color: var(--text-neutral-stronger);\n}\n\n.pdfError {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-2);\n  padding: var(--spacing-4);\n  color: var(--status-error);\n}\n\n.pageLoading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--spacing-2);\n  color: var(--text-neutral-stronger);\n  font-size: var(--font-size-sm);\n}\n\n.noPdf {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-2);\n  flex: 1;\n  color: var(--text-neutral-stronger);\n}\n\n.noPdfIcon {\n  width: var(--spacing-4);\n  height: var(--spacing-4);\n}\n\n/* Responsive Design */\n@media (max-width: var(--grid-breakpoint-xs)) {\n  .container {\n    padding: var(--spacing-2);\n    height: auto;\n    min-height: 100vh;\n  }\n\n  .header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: var(--spacing-2);\n  }\n\n  .actions {\n    justify-content: center;\n  }\n\n  .pdfDocument {\n    padding: var(--spacing-1);\n  }\n\n  .pdfPage {\n    max-width: 100%;\n    height: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `mhCJxb`,
	"header": `dVBnqb`,
	"breadcrumb": `an1aL5`,
	"actions": `amfJQC`,
	"downloadButton": `H9gwaS`,
	"pdfContainer": `mabNUb`,
	"pdfDocument": `IcOGDF`,
	"pdfPage": `bpFoWL`,
	"loadingContainer": `DW7Ay1`,
	"loading": `cPZka2`,
	"loadingIcon": `nqfUuL`,
	"spin": `TOYuqD`,
	"error": `ny0yUK`,
	"errorIcon": `hKLUMP`,
	"pdfLoading": `XouMaG`,
	"pdfError": `UI7UZW`,
	"pageLoading": `gKcqBe`,
	"noPdf": `qBjSUO`,
	"noPdfIcon": `HqCty6`
};
module.exports = ___CSS_LOADER_EXPORT___;
